function deferFilterjQuery() {
    if (window.jQuery) {
        jQuery(function(){
          // On load/reload
          var pt_on_load = function() {
            // Accordion
            

          	// Search
            jQuery('.pt-display-search').not('.has_group_selected').find('input.fm-search-box').show();

          	// Drop downs
            jQuery('.pt-display-dropdown').each(function( index ) {
                jQuery(this).find('h4').after(jQuery(this).find('.filter-clear'));
            });

            jQuery('.pt-display-dropdown .scroll-content').each(function( index ) {
                if(jQuery(this).find('li.selected').length) {
                    var selected = jQuery.map(
                        jQuery(this).find('li.selected a'),
                            function(element){
                                return jQuery(element).text();
                            }
                      ).join(", ");

                  if (selected.length < 30) {
                    jQuery(this).before('<div class="menu-trigger">' + selected +'</div>');
                  } else {
                     jQuery(this).before('<div class="menu-trigger">' + jQuery(this).find('li.selected').length + ' Selected </div>');
                  }
                }
                else {
                    jQuery(this).before('<div class="menu-trigger">'+ jQuery(this).closest('.filter-group').find('h4').text() +'</div>');
                }
            });

          	// View more
            

            jQuery('.filter-menu li a').attr('title', function() {
              return (jQuery(this).closest('li').hasClass('selected') ? "Clear filter: " : "Add filter: ") + jQuery(this).text();
            });
          }

          pt_on_load();

          // Mobile filter button
          
          jQuery(document).on('click', '.filter-menu .pt-mobile-header a', function(e){
            if(e.handled !== true) {
              if (jQuery('.pt-nav-toggle').hasClass('active')) {
                jQuery('.filter-menu').removeClass('pt-expand');
              } else {
                jQuery('.filter-menu').addClass('pt-expand');
              }

              jQuery('.pt-nav-toggle').toggleClass('active');
              e.preventDefault();
              e.handled = true;
            }
          });

          

          // Accordion
          

          // Search
          jQuery(document).on('keyup', '.filter-group input.fm-search-box', function () {
            var value = this.value.toLowerCase();
            jQuery(this).closest('.filter-group').find('li').each(function () {
              if (jQuery(this).text().toLowerCase().search(value) > -1) {
                jQuery(this).show(100);
              } else {
                jQuery(this).hide(100);
              }
            });
          });

          // Drop downs
          jQuery(document).on('click','.pt-display-dropdown .menu-trigger',function() {
            jQuery(this).next('.scroll-content').css('top', jQuery(this).position().top + jQuery(this).height() + 1).css('left', jQuery(this).position().left);
            jQuery(this).next('.scroll-content').slideToggle('fast');
          });

          jQuery(document).on('mouseleave', '.pt-display-dropdown .scroll-content', function() {
            jQuery(this).slideUp('fast');
          });

          // Apply button
          

          // Ajax
          
      });
    }
    else {
        setTimeout(function() { deferFilterjQuery() }, 50);
    }
}

deferFilterjQuery();
